import request from '@/utils/request';

export async function reqFetchAdmins(params) {
  return request('/api/fetch_admins', {
    method: 'POST',
    data: params,
  });
}